export const yupToKV = yupError => {
  let error = {}

  yupError.inner.forEach(err => {
    const path = err.path.replaceAll('"', '')
    process.env.NODE_ENV === 'development' && console.log(path)
    error[path] = err.message
  })

  return error
}
